// extracted by mini-css-extract-plugin
module.exports = {"root":"Hamburger_root__1J3K8","box":"Hamburger_box__1WPeE","inner":"Hamburger_inner__kKUM7","isExpanded":"Hamburger_isExpanded__22DSG"};